import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'
import { get } from '@/common/request'
import indexRoutes from './modules/index'
import adminRoutes from './modules/admin/admin'
import userRoutes from './modules/user'
import articleRoutes from './modules/article'
import agentRoutes from './modules/agent'
import editorRoutes from './modules/editor'
import genRoutes from './modules/gen'
import toolsRoutes from './modules/tools'
import siteRoutes from './modules/site'
import creatorRoutes from './modules/creator'
Vue.use(VueRouter)

// 重写路由的push和replace方法,统一处理导航错误
const originalPush = VueRouter.prototype.push
const originalReplace = VueRouter.prototype.replace

VueRouter.prototype.push = function (location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalPush.call(this, location, onResolve, onReject)
  }
  return originalPush.call(this, location).catch((err) => err)
}

VueRouter.prototype.replace = function (location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalReplace.call(this, location, onResolve, onReject)
  }
  return originalReplace.call(this, location).catch((err) => err)
}

// 路由配置
const routes = [
  ...indexRoutes,
  ...adminRoutes,
  ...userRoutes,
  ...articleRoutes,
  ...agentRoutes,
  ...editorRoutes,
  ...genRoutes,
  ...toolsRoutes,
  ...siteRoutes,
  ...creatorRoutes
]

const router = new VueRouter({
  mode: 'hash',
  routes
})

// 路由守卫
router.beforeEach(async (to, from, next) => {
  // 设置页面标题
  document.title = to.meta.title

  // 处理URL参数
  if (to.query.mpAppId) localStorage.setItem('mpAppId', to.query.mpAppId)
  if (to.query.token) localStorage.setItem('token', to.query.token)
  if (to.query.inviteCode) localStorage.setItem('inviteCode', to.query.inviteCode)

  // 获取应用信息
  if (!store.state.vuex_appInfo) {
    const appInfo = await get('/app/info')
    store.commit('mStore', { name: 'vuex_appInfo', value: appInfo })
  }

  const token = localStorage.getItem('token')
  const requiresAuth = to.matched.some((record) => record.meta.requireAuth)
  const isLoginPage = to.path === '/user/login'

  // 处理未登录状态
  if (!token && requiresAuth && !isLoginPage) {
    return next({
      path: '/user/login',
      query: { redirect: to.fullPath }
    })
  }

  // 获取用户信息
  if (token && !store.state.vuex_userInfo) {
    try {
      const userInfo = await get('/user/info')
      store.commit('mStore', { name: 'vuex_userInfo', value: userInfo })
    } catch (error) {
      localStorage.removeItem('token')
      return next({
        path: '/user/login',
        query: { redirect: to.fullPath }
      })
    }
  }

  // 检查管理员权限
  const requiresAdmin = to.matched.some((record) => record.meta.requireAdmin)
  if (requiresAdmin) {
    const userInfo = store.state.vuex_userInfo
    const isAdmin = userInfo && userInfo.role === 'ADMIN'
    if (!isAdmin) {
      return next('/')
    }
  }

  // 检查是否需要代理
  if (to.matched.some((record) => record.meta.requireAgent)) {
    if (!store.state.vuex_userInfo.isAgent) {
      next('/agent/poster')
      return
    }
  }

  // 检查是否需要站点管理员权限
  if (to.matched.some((record) => record.meta.requireSiteAdmin)) {
    if (!store.state.vuex_userInfo.isSiteAdmin) {
      next('/')
      return
    }
  }

  next()
})

export default router
